import React from 'react'
import { convertUTCtoMSK, formatSum } from '../../../../../../../utils'
import { PayoutTokenLink } from '../../../../../../common/PayoutTokenLink'
import { UI_STATUS_LABEL } from '../../core/consts'
import { OverpaymentHistoryItem } from '../../core/response.types'
import { uiStatusColor } from '../../core/status'

const cell: React.CSSProperties = { padding: '4px 8px 2px 0', color: 'var(--bs-body-color)', whiteSpace: 'nowrap' }
const head: React.CSSProperties = { ...cell, paddingBottom: 4, fontWeight: 600, textAlign: 'left' }

export const OverpaymentHistoryTable: React.FC<{ items: OverpaymentHistoryItem[] }> = ({ items }) => (
  <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 12 }}>
    <thead>
      <tr style={{ borderBottom: '1px solid var(--bs-border-color)' }}>
        <th style={head}>Создана</th>
        <th style={head}>Сумма</th>
        <th style={head}>Статус</th>
        <th style={head}>Компенсационная выплата</th>
      </tr>
    </thead>
    <tbody>
      {items.map((o) => (
        <tr key={o.id} style={{ borderBottom: '1px solid var(--bs-border-color)' }}>
          <td style={cell}>{convertUTCtoMSK(o.createdAt)}</td>
          <td style={cell}>{`${formatSum(o.amount)} ${o.currency}`}</td>
          <td style={cell}>
            <span className={`badge bg-${uiStatusColor(o.status)}`}>{UI_STATUS_LABEL[o.status]}</span>
          </td>
          <td style={cell}>
            <PayoutTokenLink token={o.compensationPayoutToken} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
)
